import { MONTHS_TO_DISPLAY } from '../../constants/calendar';
import { ICalendarDay } from '../../types/calendar';
import { updateCalendarData } from '../../utils/calendar';
import { ICalendarState } from './types';

interface IClickOnDate {
  type: 'calendar/click-on-date';
  day: ICalendarDay;
}

interface IClickNextPage {
  type: 'calendar/next-page';
}

interface IClickPrevPage {
  type: 'calendar/prev-page';
}

interface IResetUpdated {
  type: 'calendar/reset-updated';
}

type TCalendarActions = IClickOnDate | IClickNextPage | IClickPrevPage | IResetUpdated;

export function calendarReducer(state: ICalendarState, action: TCalendarActions): ICalendarState {
  switch (action.type) {
    case 'calendar/click-on-date': {
      let from = action.day.date;
      let to = null;
      let updated = false;

      if (state.selecting) {
        /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
        from = state.from!;
        to = action.day.date;
        updated = true;

        if (from > to) {
          to = from;
          from = action.day.date;
        }
      }

      return {
        ...state,
        from,
        to,
        calendar: updateCalendarData({ calendar: state.initialCalendar, from, to }),
        selecting: !state.selecting,
        updated,
      };
    }
    case 'calendar/next-page':
      if (state.isNextPageAvailable) {
        const nextCurrentPage = state.currentPage + 2;

        return {
          ...state,
          currentPage: nextCurrentPage,
          isPrevPageAvailable: nextCurrentPage > 1,
          isNextPageAvailable: nextCurrentPage < state.initialCalendar.length - MONTHS_TO_DISPLAY - 1,
        };
      }

      return state;
    case 'calendar/prev-page':
      if (state.isPrevPageAvailable) {
        const nextCurrentPage = state.currentPage - 2;

        return {
          ...state,
          currentPage: nextCurrentPage,
          isPrevPageAvailable: nextCurrentPage > 1,
          isNextPageAvailable: nextCurrentPage < state.initialCalendar.length - MONTHS_TO_DISPLAY - 1,
        };
      }

      return state;

    case 'calendar/reset-updated':
      return {
        ...state,
        updated: false,
      };

    default:
      return state;
  }
}
